import { Inject, Injectable } from '@angular/core'
import { Config, ConfigInitializerService, RootConfig, WindowRef } from '@spartacus/core'
import { Observable, of } from 'rxjs'
import { EbCountryService } from '../../site-context/services/eb-country.service'
import { EbLanguageService } from '../../site-context/services/eb-language.service'

/**
 * Provides support for CONFIG_INITIALIZERS
 */
@Injectable({
  providedIn: 'root'
})
export class EbConfigInitializerService extends ConfigInitializerService {
  constructor(
    config: Config,
    @Inject(RootConfig) rootConfig: Config,
    protected winRef: WindowRef,
    protected ebCountryService: EbCountryService,
    protected languageService: EbLanguageService
  ) {
    super(config, undefined, rootConfig)
    const urlParts = this.winRef.location.href.split('/')
    // verify that first parameter is existing and a country (upper case) and not a language(lower case)
    if (
      (!urlParts?.[3] || urlParts?.[3] !== urlParts?.[3].toUpperCase()) &&
      urlParts[3]?.length === 2
    ) {
      this.ebCountryService.setActive(this.ebCountryService.checkForStoredCountryOrFallback())
    }
    // verify that first parameter is existing and a country (upper case) and not a language(lower case)
    if (
      (!urlParts?.[4] || urlParts?.[4] !== urlParts?.[4].toLowerCase()) &&
      urlParts[4]?.length === 2
    ) {
      this.languageService.setActive(this.languageService.checkForStoredLanguageOrFallback())
    }
  }

  get isStable(): boolean {
    return super.isStable
  }

  getI18nStable(): Observable<Config> {
    return super.getStable('i18n')
  }

  getStable(...scopes: string[]): Observable<Config> {
    if (scopes[0] === 'i18n') {
      return of({ i18n: { resources: {} } })
    }

    return super.getStable(...scopes)
  }
}
